import { useEffect, useState } from "react";
import {
  fetchAndSetData,
  fetchArtistList,
  fetchSongRequestList,
  fetchUserList,
} from "../api/fetch.api";
import {
  update컬렉션HomebrewPlaylist필드SongList,
  update컬렉션Song,
  update컬렉션SongRequest,
  update컬렉션User필드LikeSongListAndPlaylist,
  update컬렉션User필드SongRequestList,
} from "../api/collectionChange.api";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  artistListState,
  songRequestListState,
  userListState,
} from "../atom/atom";
import {
  update모든아티스트정보동기화,
  update아티스트네임,
  user컬렉션songRequestList필드songRequest컬렉션동기화,
} from "../api/update.api";
import { useFilePicker } from "../hooks/file/useFilePicker";
import SurveyDashboard from "../components/SurveySection";

function TestPage() {
  const [audioSrc, setAudioSrc] = useState<string>("");
  const [searchKeyword, setSearchKeyword] = useState<string>("");

  const totalArtistList = useRecoilValue(artistListState);
  const [totalSongRequestList, setTotalSongRequestList] =
    useRecoilState(songRequestListState);
  const [totalUserList, setTotalUserList] = useRecoilState(userListState);

  useEffect(() => {
    if (totalUserList.length === 0)
      fetchAndSetData(fetchUserList, setTotalUserList);

    if (totalSongRequestList.length === 0)
      fetchAndSetData(fetchSongRequestList, setTotalSongRequestList);
  }, [totalSongRequestList, totalUserList]);

  const song컬렉션변경반영 = async () => {
    await update컬렉션HomebrewPlaylist필드SongList();
    await update컬렉션Song();
    await update컬렉션User필드LikeSongListAndPlaylist();
  };

  const songRequest컬렉션변경반영 = async () => {
    console.log("songRequest컬렉션변경반영 실행 !!");
    await update컬렉션SongRequest(totalArtistList);
    await update컬렉션User필드SongRequestList(totalArtistList);
  };

  const user컬렉션songRequest필드동기화 = async () => {
    await user컬렉션songRequestList필드songRequest컬렉션동기화({
      totalUserList,
      totalSongRequestList,
    });
  };

  const artist컬렉션동기화 = async () => {
    const totalArtistList = await fetchArtistList();
    await update모든아티스트정보동기화(totalArtistList);
  };
  const artist모델네임 = async () => {
    await update아티스트네임();
  };

  const { selectedFile, handleFileSelect } = useFilePicker();

  const handleFilePick = (file: File) => {
    const fileUrl = URL.createObjectURL(file);
    handleFileSelect(file);
    setAudioSrc(fileUrl);
  };

  return (
    <div>
      <h1>Test Page</h1>
      {/* <MigrationComponent /> */}
      <SurveyDashboard />

      {/* <SearchKeywordsGenerator />
      <SearchTester />
      <GuideSearchTester />

      <input
        type="text"
        placeholder="검색 테스트"
        value={searchKeyword}
        onChange={(e) => setSearchKeyword(e.target.value)}
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 4,
        }}
      >
        <p></p>
        <button onClick={song컬렉션변경반영}>song컬렉션변경반영</button>
        <button onClick={songRequest컬렉션변경반영}>
          songRequest컬렉션변경반영
        </button>
        <button onClick={user컬렉션songRequest필드동기화}>
          user컬렉션songRequest필드 songRequest컬렉션에서 따오기
        </button>
        <div>
          <p>1번 누르고 2번</p>
          <button onClick={artist모델네임}>
            1. artist모델네임 (model 없거나 '' 인경우 null 처리)
          </button>
          <button onClick={artist컬렉션동기화}>
            2. artist컬렉션동기화 (modelName, isMale 필드 aritst컬렉션 기준으로
            동기화)
          </button>
        </div>
        <div>
          <button onClick={updateUserCollectionWithCredit}>
            user 컬렉션에 Credit 관련 필드 추가
          </button>
        </div>
      </div>

      <div>
        <h3>오디오 파일 선택 및 재생</h3>
        <FilePicker
          onFileSelect={handleFilePick}
          transformFile={normalizeAudioFile}
          accept="audio/*"
          label="오디오 파일 선택"
        />

        {audioSrc && selectedFile && (
          <div>
            <h2>오디오 미리듣기:</h2>
            <audio controls src={audioSrc}>
              Your browser does not support the audio element.
            </audio>
            <FileUploader file={selectedFile} storagePath="" />
          </div>
        )}
      </div> */}
    </div>
  );
}

export default TestPage;
